module.exports = __webpack_public_path__ + "static/media/add-template.b470a73c.png";